export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [
      { method: 'GET', path: '/internalcontrol/purchase_method_batch/detail/info' },
      { method: 'GET', path: '/internalcontrol/purchase_method_batch/info' },
      { method: 'GET', path: '/internalcontrol/status_manage/config' },
    ]
  },
  getByAuth: {
    funKey: 'getByAuth',
    name: '查看权限内的',
    apis: [
      { method: 'GET', path: '/internalcontrol/purchase_method_batch/detail/info/by_auth' },
      { method: 'GET', path: '/internalcontrol/purchase_method_batch/info/my' },
      { method: 'GET', path: '/internalcontrol/status_manage/config' }
    ]
  }
}